var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"ui-input-radio",class:{
        _active: _vm.checked,
    }},[_c('input',{staticClass:"ui-input-radio__input",attrs:{"type":"radio","name":_vm.name},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.updateModel($event.target.checked)}}}),_c('div',{staticClass:"ui-input-radio__check"})])
}
var staticRenderFns = []

export { render, staticRenderFns }